import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field, SubmissionError } from 'redux-form'
import { Button } from 'semantic-ui-react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { AddBankContainer } from './styled'
import { getBusinessPartners } from 'ducks/options'
import { getBPGeneralView, getBPCompanies } from 'ducks/vendorMaintenance'
import { getHrmsMembers, getAllMembers } from 'ducks/member'
import r from 'reactotron-react-js'

const LoadVendorModal = (props) => {
  const { valueForm, onLoadBusinessPartnerSuccess, onLoadBusinessPartnerWarning, showLoadVendorModal, 
    businessPartners, vendorCompanies, username, members, memberLoading, vmId } = props

  const submitLoadBusinessPartner = (values) => {
    const { vendorCode, companyCode } = values
    props.getBPGeneralView(vendorCode, companyCode, onLoadBusinessPartnerSuccess, onLoadBusinessPartnerWarning, vmId)
  }

  React.useEffect(() => {
    if (!businessPartners.data.length && !businessPartners.loading) {
      props.getBusinessPartners()
    }

    if (!members.length && !memberLoading) {
      // props.getHrmsMembers()
      props.getAllMembers()
    }
  }, [])

  const onSelectVendor = (data) => {
    props.getBPCompanies(data)
  }

  const onClickLoadButton = () => {
    const validateResult = validate(valueForm, vendorCompanies)

    if (Object.keys(validateResult).length) {
      throw new SubmissionError(validateResult)
    } else {
      submitLoadBusinessPartner(valueForm)
    }
  }

  const disableLoadButton = () => {
    if (vendorCompanies.loading) {
      return true
    } else {
      if (vendorCompanies.data.length > 0) {
        return (!valueForm.vendorCode || !valueForm.companyCode)
      } else {
        return (!valueForm.vendorCode)
      }
    }
  }

  const getCurrentUserZempCode = () => {
    if (username) {
      var member = members.find(m => m.username === username)
      if (member !== undefined && member !== null) {
        if (member.employeeCode) {
          return `E${member.employeeCode}`
        }
      }
    }
    
    return null
  }

  const vendorList = () => {
    var code = getCurrentUserZempCode()
    var vend = businessPartners.data.find(x => x.value === code)
    // r.log({ vend })
    if (code) {
      if (vend) {
        return businessPartners.data.filter(x => !x.value.startsWith('E') || x.value === code || x.taxId === vend.taxId)
      } else {
        return businessPartners.data.filter(x => !x.value.startsWith('E') || x.value === code)
      }
    } else {
      return businessPartners.data.filter(x => !x.value.startsWith('E'))
    }
  }

  return (
    <Dialog open={true} className='dialog-full-height' maxWidth='sm' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>Load Business Partner</DialogTitle>
      <DialogContent>
        <form>
          <AddBankContainer>
            <div className='rowFields'>
              <Field
                name='vendorCode'
                label='Business Partner Number'
                require
                type={type.select}
                loading={businessPartners.loading}
                options={vendorList()}
                specialOnChange={onSelectVendor}
                component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field
                name='companyCode'
                label='Company'
                require={
                  vendorCompanies.data.length > 0 && !vendorCompanies.loading
                }
                type={type.select}
                loading={vendorCompanies.loading}
                options={vendorCompanies.data}
                component={FieldInput} />
            </div>
          </AddBankContainer>
        </form>
      </DialogContent>
      <DialogActions>
        <form>
          <Button
            color='blue'
            content='Load'
            disabled={disableLoadButton()}
            type='button'
            onClick={() => onClickLoadButton()}
          />
          <Button
            color='red'
            content='Cancel'
            onClick={() => showLoadVendorModal(false)}
          />
        </form>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const { vendorCode, companyCode } = props
  const valueForm = getFormValues('formLoadVendor')(state) || {}
  return ({
    valueForm,
    initialValues: {
      vendorCode: valueForm.vendorCode || vendorCode || '',
      companyCode: valueForm.companyCode || companyCode || '',
    },
    businessPartners: state.options.businessPartners,
    vendorCompanies: state.vendorMaintenance.vendorCompanies,
    username: state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : '',
    members: state.member.members,
    memberLoading: state.member.memberLoading
  })
}
  
const mapDispatchToProps = {
  getBusinessPartners,
  getBPGeneralView,
  getBPCompanies,
  getHrmsMembers,
  getAllMembers
}

const validate = (values, vendorCompanies) => {
  const errors = {}
  if (!values.vendorCode) errors.vendorCode = 'Require!'

  if (vendorCompanies.data.length > 0 && !values.companyCode) errors.companyCode = 'Require!'

  return errors
}

const LoadVendorForm = reduxForm({
  form: 'formLoadVendor',
  enableReinitialize: true
})(LoadVendorModal)

export default connect(mapStateToProps, mapDispatchToProps)(LoadVendorForm)